import { render, staticRenderFns } from "./BitRelational.vue?vue&type=template&id=2ce483a0&scoped=true"
import script from "./BitRelational.vue?vue&type=script&lang=js"
export * from "./BitRelational.vue?vue&type=script&lang=js"
import style0 from "./BitRelational.vue?vue&type=style&index=0&id=2ce483a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce483a0",
  null
  
)

export default component.exports